<template>
  <div>
    <div class="mb-4">
      <label>Название</label>
      <va-input v-model="tileTitle" placeholder="Введите название" />
    </div>
    <div class="mb-4">
      <label>Ссылка</label>
      <va-input v-model="tileLink" placeholder="/catalog/category" />
    </div>
    <div class="upload-block mb-4">
      <label for="tile-img-edit" class="upload-label"
        >Загрузить новое фото</label
      >
      <input
        id="tile-img-edit"
        class="upload-img-input"
        accept="image/x-png,image/jpg,image/jpeg"
        type="file"
        @change="onFilePicked"
      />
    </div>
    <div
      v-if="imageData !== '' || currentTile.image || currentTile.url"
      class="mb-4"
    >
      <img :src="imageData || currentTile.image || currentTile.url" alt="" />
    </div>
    <div class="mb-4">
      <label>Цвет фона</label>
      <input v-model="tileBgColor" type="color" />
      <va-input v-model="tileBgColor" placeholder="#D8E0EB" />
    </div>
    <div class="mb-4">
      <label>Порядок</label>
      <va-input v-model.number="tileOrder" type="number" placeholder="0" />
    </div>
    <div class="mb-4">
      <label>Статус</label>
      <va-checkbox v-model="tileActive" />
      <span>{{ tileActive ? "Включен" : "Выключен" }}</span>
    </div>
    <div class="mt-4 text-center">
      <va-button color="primary" type="button" @click="$emit('hide', true)">
        Отменить
      </va-button>

      <va-button color="success" type="submit" @click="submit">
        Сохранить
      </va-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";

export default {
  props: {
    tile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      file: null,
      imageData: "",
      tileTitle: "",
      tileLink: "",
      tileBgColor: "#D8E0EB",
      tileOrder: 0,
      tileActive: true,
      currentTile: {},
    };
  },
  created() {
    this.currentTile = { ...this.tile };
    this.tileTitle = this.tile.title || "";
    this.tileLink = this.tile.link || "";
    this.tileBgColor = this.tile.bg_color || "#D8E0EB";
    this.tileOrder = this.tile.order || 0;
    this.tileActive = Boolean(this.tile.active);
  },
  methods: {
    ...mapActions({
      fetchCategoryTiles: "categoryTiles/getCategoryTiles",
    }),
    onFilePicked(event) {
      if (event.target.files && event.target.files[0]) {
        this.file = event.target.files[0];
        const imgUrl = URL.createObjectURL(this.file);
        this.imageData = imgUrl;
      }
    },
    async submit() {
      try {
        const data = {
          title: this.tileTitle,
          link: this.tileLink,
          bg_color: this.tileBgColor,
          order: this.tileOrder,
          active: this.tileActive,
        };

        // Если выбрано новое фото, загружаем его
        if (this.file) {
          const formData = new FormData();
          formData.append("file", this.file, this.file.name);
          const fileInfo = await api.post("/upload-file", formData);
          data.photo_id = fileInfo.data.id;
        }

        await api.put(`/admin/category-tiles/${this.tile.id}`, data);
        await this.fetchCategoryTiles();
        this.$emit("hide", true);
      } catch (error) {
        console.error("Error updating category tile:", error);
        return error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}
.upload-block {
  position: relative;
}
.upload-img-input {
  appearance: none;
  visibility: hidden;
}
.upload-label {
  padding: 0.375rem 1.25rem;
  background-color: rgb(44, 130, 224);
  color: #fff;
  font-weight: bold;
  border-radius: 1.5rem;
  cursor: pointer;
  display: inline-block;
}
</style>
